import React from 'react';
import LoginForm from '../../components/organism/LoginForm';
import RegisterForm from '../../components/organism/RegisterForm';
import { Box } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import PasswordRecovery from '../../components/organism/PasswordRecovery';
import styles from './Login.module.css';

const Login: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const recoveryToken = searchParams.get('recovery') || '';
  const [value, setValue] = React.useState(recoveryToken ? 'recover' : 'login');

  React.useEffect(() => {
    if (recoveryToken) {
      setValue('recover');
    }
  }, [recoveryToken]);

  const handleRecovered = () => {
    setSearchParams({});
    setValue('login');
  };
  return (
    <Box className={styles.page}>
      <Box className={styles.leftPanel}>
        <div className={styles.leftContent}>
          <img
            className={styles.leftLogo}
            src="https://temporario.umespaco.com/wp-content/uploads/2024/09/umespaco-com.png"
            alt="UmEspaco"
          />
          <div className={styles.leftHeadline}>
            Os melhores
            <br />
            espaços para
            <br />
            eventos em
            <br />
            um só lugar!
          </div>
        </div>
      </Box>

      <Box className={styles.rightPanel}>
        <Box className={styles.formCard}>
          <img
            className={styles.brandLogo}
            src="https://temporario.umespaco.com/wp-content/uploads/2024/09/umespaco-com.png"
            alt="UmEspaco"
          />
          <div className={styles.formTitle}>
            {value === 'login'
              ? 'Já Possui Conta?'
              : value === 'register'
              ? 'Crie uma Conta'
              : value === 'forgot'
              ? 'Recuperar Senha'
              : 'Redefinir Senha'}
          </div>
          <div className={styles.divider} />

          {value === 'login' ? (
            <>
              <LoginForm />
              <div className={styles.supportActions} style={{ marginTop: 15 }}>
                <div className={styles.supportItem}>
                  <button className={styles.linkButton} onClick={() => setValue('forgot')}>
                    Esqueceu a senha?
                  </button>
                </div>
                <div className={styles.supportItem}>
                  <button className={styles.linkButton} onClick={() => setValue('register')}>
                    Ainda não possui conta?
                  </button>
                </div>
              </div>
            </>
          ) : value === 'register' ? (
            <>
              <RegisterForm onSwitchToLogin={() => setValue('login')} />
              <div className={styles.supportRow} style={{ marginTop: 20, fontSize: 13 }}>
                <button
                  style={{ fontSize: 15 }}
                  className={styles.linkButton}
                  onClick={() => setValue('login')}
                >
                  Já possui conta?
                </button>
              </div>
            </>
          ) : (
            <PasswordRecovery
              mode={value}
              recoveryToken={recoveryToken}
              onBackToLogin={() => setValue('login')}
              onRecovered={handleRecovered}
            />
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default Login;
